import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ActivityLogsHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/activity-logs'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'activitylogs_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'activitylogs_list',
          meta: {
            permissions: ['administrator', 'activity_logs_view'],
          },
          component: ActivityLogsHome,
        },
      ],
    },
  ],
};
